import * as yup from 'yup';

export interface FormProps {
  occurrenceDescription: string;
  occurrenceDate: any;
  estimateLoss: string;
}

const minDate = new Date('1980-01-01').setHours(0, 0, 1);
const maxDate = new Date().setHours(23, 59, 59);
const convertToDate = (date: string | undefined | null) => {
  if (date) {
    const d = date.split('/');
    const convert = new Date(`${d[1]}/${d[0]}/${d[2]}`).setHours(0, 0, 1);
    return convert;
  }
  return maxDate;
};

const regexDate = /^(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/(\d{4})$/;

export const schema: yup.SchemaOf<FormProps> = yup.object().shape({
  occurrenceDescription: yup.string().required('Campo Obrigatório'),
  occurrenceDate: yup
    .string()
    .required('Campo Obrigatório')
    .matches(regexDate, 'Data inválida')
    .test({
      name: 'noFutureDate',
      params: { maxDate },
      message: `Data não deve ser futura`,
      test: value => maxDate > convertToDate(value),
    })
    .test({
      name: 'mininumDate',
      params: { minDate },
      message: `Data não deve ser anterior a 1980`,
      test: value => minDate < convertToDate(value),
    }),
  estimateLoss: yup
    .string()
    .matches(
      /^\s*R\$\s*\d{1,3}(\.\d{3})*(,\d{2})?\s*$/,
      'O valor inserido não é válido.',
    )
    .test('max', 'O valor máximo permitido é R$ 30 milhões.', value => {
      const floatValue = parseFloat(
        value.replace(/[^0-9,]/g, '').replace(',', '.'),
      );
      return floatValue <= 30000000;
    })
    .test('min', 'Valor deve ser maior que R$ 0,00', value => {
      const floatValue = parseFloat(
        value.replace(/[^0-9,]/g, '').replace(',', '.'),
      );
      return floatValue > 0;
    })
    .required('O campo estimateLoss é obrigatório.'),
});

export const schemaDraft: yup.SchemaOf<any> = yup.object().shape(
  {
    occurrenceDate: yup
      .string()
      .nullable()
      .notRequired()
      .when('occurrenceDate', {
        is: (value: string) => value?.length,
        then: rule => rule.matches(regexDate, 'Data inválida'),
      })
      .when('occurrenceDate', {
        is: (value: string) => RegExp(regexDate).exec(value),
        then: rule =>
          rule.test({
            name: 'noFutureDate',
            params: { maxDate },
            message: `Data não deve ser futura`,
            test: value => maxDate > convertToDate(value),
          }),
      })
      .when('occurrenceDate', {
        is: (value: string) => RegExp(regexDate).exec(value),
        then: rule =>
          rule.test({
            name: 'mininumDate',
            params: { minDate },
            message: `Data não deve ser anterior a 1980`,
            test: value => minDate < convertToDate(value),
          }),
      }),
    estimateLoss: yup
      .string()
      .matches(
        /^\s*R\$\s*\d{1,3}(\.\d{3})*(,\d{2})?\s*$/,
        'O valor inserido não é válido.',
      )
      .test('max', 'O valor máximo permitido é R$ 30 milhões.', value => {
        const floatValue = parseFloat(
          value.replace(/[^0-9,]/g, '').replace(',', '.'),
        );
        return floatValue <= 30000000;
      })
      .test('min', 'Valor deve ser maior que R$ 0,00', value => {
        const floatValue = parseFloat(
          value.replace(/[^0-9,]/g, '').replace(',', '.'),
        );
        return floatValue > 0;
      }),
  },
  [
    ['occurrenceDate', 'occurrenceDate'],
    ['estimateLoss', 'estimateLoss'],
  ],
);
